import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();


// WEBPACK FOOTER //
// ./src/components/common/History.js